<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
#app {
  margin: auto;
  padding: 0;
}
@font-face {
  font-family: 'NumFont';
  src: url('@/assets/fonts/DS-DIGI-1.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

</style>
